module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aghbA"))).then(() => parcelRequire('iDabs'));